<template>
  <div>
    <v-dialog
      v-if="file_url"
      v-model="dialog_file"
      scrollable
      max-width="800px"
      transition="dialog-transition"
      persistent
      :fullscreen="fullscreen"
    >
      <v-card :style="fullscreen ? 'border-radius:0px' : 'border-radius:12px'" v-if="dialog_file">
        <v-card-title primary-title>
          <div class="headline mb-0">{{title}}</div>
          <v-spacer></v-spacer>
          <v-btn 
            small
            color="btn-primary"
            class="ml-2" 
            @click="setFullScreen" 
          ><v-icon>mdi-window-maximize</v-icon></v-btn>
          <v-btn 
            small
            color="btn-primary"
            class="ml-2" 
            @click="$emit('closeDialog')" 
          ><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <pdf v-if="file_kind == 'application/pdf'" :src="file_url"></pdf>
          <img width="100%" v-if="file_kind != 'application/pdf'" :src="file_url"/>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn v-if="file_url" small color="btn-primary" :href="file_url" target="_blank"><v-icon left>mdi-file</v-icon>Download</v-btn>
          <v-btn small color="btn-error" @click="$emit('closeDialog')"><v-icon left small>mdi-close</v-icon>Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  name: 'DialogShowFile',
  components: {
    pdf
  },
  props: {
    file_url: {
      type: String,
      default: null
    },
    file_kind: {
      type: String,
      default: null
    },
    dialog_file: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      fullscreen: false,
    }
  },
  mounted() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    setFullScreen() {
      this.fullscreen = !this.fullscreen
    }
  },

}
</script>

<style lang="scss" scoped>

</style>